// In-app history never leaves the authenticated shell, including direct opens.
const KEY = "standard-app-navigation-v1";
export function isAppShellLocation(location: string): boolean {
  return (
    /^\/(?:client|coach|community)(?:[/?#]|$)/.test(location) &&
    !location.startsWith("//")
  );
}
export function updateAppRouteStack(
  stack: readonly string[],
  location: string
): string[] {
  const valid = stack.filter(isAppShellLocation);
  if (!isAppShellLocation(location) || valid.at(-1) === location) return valid;
  if (valid.at(-2) === location) return valid.slice(0, -1);
  return [...valid, location].slice(-40);
}
export function popAppRouteStack(stack: readonly string[], location: string) {
  const current = updateAppRouteStack(stack, location);
  const next = current.slice(0, -1);
  return { stack: next, target: next.at(-1) ?? null };
}
function read(): string[] {
  try {
    const value = JSON.parse(sessionStorage.getItem(KEY) ?? "[]");
    return Array.isArray(value)
      ? value.filter(
          (item): item is string =>
            typeof item === "string" && isAppShellLocation(item)
        )
      : [];
  } catch {
    return [];
  }
}
function write(stack: string[]) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(stack));
  } catch {
    /* private mode */
  }
}
export function recordAppLocation(location: string) {
  write(updateAppRouteStack(read(), location));
}
export function consumeAppBackTarget(location: string): string | null {
  const result = popAppRouteStack(read(), location);
  write(result.stack);
  return result.target;
}
export function safeAppReturnTo(
  search: string,
  current: string
): string | null {
  const target = new URLSearchParams(search).get("returnTo");
  return target &&
    isAppShellLocation(target) &&
    target.split(/[?#]/)[0] !== current.split(/[?#]/)[0]
    ? target
    : null;
}
